module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-05@2x.457175d5.jpg";